<template>
  <div class="pictureGallery">
    <section class="pictureGallery__preview" v-if="imgList?.length > 1">
      <div
          v-for="(item, index) in imgList"
          class="pictureGallery__previewItem"
          :key="item"
          @click="selectedImageIndex=index"
      >
        <img
            class="pictureGallery__image"
            :class="{'pictureGallery__image--active': selectedImageIndex === index}"
            :src="item"
            alt=""
            @error="(e)=>e.target.src = require('@/assets/img/preview_placeholder.jpg')"
        />
      </div>
    </section>
    <section class="pictureGallery__detail">
      <img
          v-if="selectedImageSource"
          class="pictureGallery__detailImage"
          :src="selectedImageSource"
          @click="openImagePreview(selectedImageSource)"
          @error="(e)=>e.target.src = require('@/assets/img/preview_placeholder.jpg')"
      />
    </section>

  </div>
</template>

<script>
import {computed, ref} from "vue";
import {openImagePreview} from "@/composables/image-preview";

export default {
  name: "PictureGallery",
  props: ['imgList'],
  setup(props) {

    const placeholder = require("@/assets/img/preview_placeholder.jpg");
    const selectedImageIndex = ref(0)
    const selectedImageSource = computed(() => {
      if(!props.imgList?.length) {
        return placeholder;
      }

      if( selectedImageIndex.value >  props.imgList.length - 1) {
        return placeholder;
      }
      return props.imgList[selectedImageIndex.value];
    })
    return {
      selectedImageSource,
      selectedImageIndex,
      openImagePreview
    }
  }
}
</script>


<style scoped lang="scss">
.pictureGallery {
  display: flex;
  width: 100%;
  min-height: 300px;

  @include respond-to('md') {
    flex-direction: column-reverse;
    gap: 12px;
  }

  &__preview {
    display: flex;
    flex-direction: column;
    gap: 14px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px;
    width: 120px;
    flex-shrink: 0;

    @include respond-to('md') {
      flex-direction: row;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      height: 80px;
      padding: 4px;
    }
  }

  &__image {
    width: 90px;
    border-radius: 8px;
    border: 3px solid rgba(0, 0, 0, 1);
    object-fit: contain;
    object-position: center;
    cursor: pointer;
    flex-shrink: 0;

    @include respond-to('md') {
      width: 70px;
      height: 70px;
    }

    &--active {
      border: 3px solid white;
    }
  }

  &__detail {
    flex: 1 1 0;
    min-width: 0;
    text-align: start;
    padding: 8px;
  }

  &__detailImage {
    max-width: 100%;
    width: 100%;
    height: auto;
    max-height: 580px;
    border-radius: 20px;
    object-fit: cover;
    object-position: center;
    cursor: zoom-in;
  }
}
</style>
